module.exports = __webpack_public_path__ + "img/776C62_292622_474039_3C342C-256px.2bacd279.png";